import locale from './locale';
export default function setLocale(custom) {
  Object.keys(custom).forEach(type => {
    // @ts-ignore
    Object.keys(custom[type]).forEach(method => {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/yup/es/setLocale.js
// module id = 848
// module chunks = 14